<template>
  <div class="image-selector-dual">
    <!-- 待选列表 -->
    <SourceList :images="sourceImageList" :selected-ids="selectedImageIds" :loading="multiState.loading"
      @add-to-edit="handleAddToEdit" />

    <!-- 编辑列表 -->
    <EditList :images="editImageList" :current-id="multiState.requestId" :edit-result-map="multiState.editResultMap"
      @switch-image="handleSwitchImage" @remove-image="handleRemoveImage" @reorder="handleReorder"
      @insert-blank="handleInsertBlank" />
  </div>
</template>

<script setup>
import { computed, nextTick } from 'vue';
import { useStore } from 'vuex';
import { saveDraft } from '@/utils/ls';
import { Sentry } from '@/utils/sentry';
import SourceList from './SourceList.vue';
import EditList from './EditList.vue';

const store = useStore();
const appState = computed(() => store.state.app);
const multiState = computed(() => store.state.multi);

// 双列数据
const sourceImageList = computed(() => store.state.multi.sourceImageList);
const editImageList = computed(() => store.state.multi.editImageList);
const selectedImageIds = computed(() => store.state.multi.selectedImageIds);

// 保存当前图片
const saveSingleImage = () => {
  const { imageExtenssion } = appState.value;
  return store.dispatch('multi/saveSingleImage', { imageExtenssion });
};

// 添加图片到编辑列表
const handleAddToEdit = (image) => {
  console.log({ "---------image--------": image })
  store.dispatch('multi/addToEditList', image);
};

// 切换图片进行编辑
const handleSwitchImage = (requestId) => {
  if (appState.value.editorLoading || appState.value.currentMenuAction) {
    return;
  }

  // 新增：空白图片快速切换路径
  if (requestId?.includes('blank')) {
    console.log('=== [空白图片] 快速切换，跳过保存 ===');

    // 空白图片无需保存当前状态，直接切换
    if (multiState.value.requestId !== requestId) {
      store.commit('app/resetCropInfo');
    }
    store.commit('multi/SET_STATE', {
      requestId: requestId,
      currentIndex: store.state.multi.editImageList.findIndex(i => i.requestId === requestId),
    });
    store.commit('app/SET_DRAWING_MODE', false);
    Sentry.setTag('requestId', requestId);

    // 立即完成，跳过save等待
    return;
  }

  if (appState.value.loadDataError) {
    doSwitch();
  } else {
    saveSingleImage()
      .then(() => {
        store.dispatch('app/discardActiveObject');
        doSwitch();
      })
      .catch(() => {
        console.error('Save image failed');
      });
  }

  function doSwitch() {
    nextTick(() => {
      saveDraft();
      // 切换图片，重置裁剪
      if (multiState.value.requestId !== requestId) {
        store.commit('app/resetCropInfo');
      }
      store.commit('multi/SET_STATE', {
        requestId: requestId,
        currentIndex: store.state.multi.editImageList.findIndex(i => i.requestId === requestId),
      });
      store.commit('app/SET_DRAWING_MODE', false);
      Sentry.setTag('requestId', requestId);
    });
  }
};

// 移除图片从编辑列表
const handleRemoveImage = (requestId) => {
  store.dispatch('multi/removeFromEditList', requestId);
};

// 拖拽排序
const handleReorder = (newOrder) => {
  store.commit('multi/REORDER_EDIT_LIST', newOrder);
};

// 插入空白图片
const handleInsertBlank = (blankImage, index) => {
  // 将空白图片插入到指定位置
  store.dispatch('multi/insertBlankImage', { blankImage, index });
};
</script>

<style lang="less" scoped>
.image-selector-dual {
  display: flex;
  height: 100%;
  overflow: hidden;
}
</style>
